<div class="min-h-screen flex flex-col bg-brand-surface text-brand-ink">
  <!-- Fixed Header -->
  <header class="fixed top-0 left-0 right-0 z-40 shadow-sm bg-brand-surface-card">
    <app-header></app-header>
  </header>

  <!-- Main Content with proper spacing -->
  <main class="flex-1 overflow-x-hidden pt-16 pb-20 sm:pb-16">
    <router-outlet></router-outlet>
  </main>

  <!-- Fixed Footer -->
  <app-footer></app-footer>

  <!-- Pricing Modal -->
  <app-pricing-modal
    *ngIf="showPricingModal"
    [initialMeters]="prefetchedMeters"
    [initialWallet]="prefetchedWallet"
    (closed)="closePricingModal()"
  ></app-pricing-modal>
</div>
